import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserSession } from '@asamco/base';
import { PostLoginProcessor } from '@asamco/base';

interface SessionCreate {
	token: string;
	backendUrl: string;
	frontendUrl: string;
}

export abstract class RemoteLoginProcessor implements PostLoginProcessor {
	constructor(private http: HttpClient) {}

	abstract GetTargetApp(): string;

	execute(userSession: UserSession): Observable<UserSession> {
		const targetApp = this.GetTargetApp();

		return this.http.post<SessionCreate>(`InnerSessions/Create/${targetApp}`, undefined)
			.pipe(
				map((session: SessionCreate) => {
					const clonedSession = JSON.parse(JSON.stringify(userSession.loggedInBackends[0]));
					clonedSession.baseUrl = session.backendUrl + '/api/';
					clonedSession.odataBaseUrl = session.backendUrl + '/api/';
					clonedSession.frontendUrl = session.frontendUrl;
					clonedSession.token = session.token;
					clonedSession.name = this.GetTargetApp();

					userSession.loggedInBackends.push(clonedSession);
					return userSession;
				})
			);
	}
}
